var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-295c15f1]{background-image:url(" + escape(require("../../../assets/ring.png")) + ");background-size:cover;position:fixed;animation:spin-data-v-295c15f1 3s infinite;width:25px;height:25px}@keyframes spin-data-v-295c15f1{0%{transform:scaleX(1)}50%{transform:scaleX(-1)}to{transform:scaleX(1)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-295c15f1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/objects/game/Ring.vue
// module id = 60
// module chunks = 0